
    export default {
        name: 'C1DropdownItem',

        inject: ['C1Dropdown'],

        props: {
            href: {
                type: String,
                default: undefined,
            },

            to: {
                type: [String, Object],
                default: undefined,
            },
        },

        computed: {
            classList() {
                return [
                    'd-flex align-items-center',
                    'd-block w-full px-4 py-2 text-sm leading-5 text-gray-700 hover:text-gray-900 hover:bg-gray-100',
                    'focus:outline-none focus:bg-gray-100 focus:text-gray-900',
                ];
            },

            localHref() {
                if (typeof this.to !== 'undefined') {
                    return undefined;
                }

                return this.href;
            },

            is() {
                if (typeof this.to !== 'undefined') {
                    return 'RouterLink';
                }

                if (typeof this.href !== 'undefined') {
                    return 'a';
                }

                return 'button';
            },
        },

        methods: {
            onClick(evt) {
                this.$emit('click', evt);
                this.closeDropdown();
            },

            closeDropdown() {
                this.C1Dropdown.close();
            },
        },
    };
